'use client';

import { useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { datadogRum } from '@datadog/browser-rum';
import { initializeDatadog } from '@/lib/datadog';

export function DatadogProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Initialize Datadog only once
    if (typeof window !== 'undefined') {
      initializeDatadog();
    }

    // Track page views
    const url = `${pathname}?${searchParams}`;
    datadogRum.addAction('page_view', { url });
  }, [pathname, searchParams]);

  return children;
}
